export function overlayButton($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {

            const init = () => {
                const body = document.body;
                const overlayInClass = 'overlay-in'
                const overlayClass = `overlay-in--${attrs.overlayButton}`;
                const overlayPanel = document.querySelector(`[overlay="${attrs.overlayButton}"]`);
                const firstInput = overlayPanel.querySelector('input, a');

                const setOverlayState = () => {

                    if (body.classList.contains(overlayInClass)) {
                        body.className = body.className.replace(/\boverlay-in.*\b/g, '');
                    } else {
                        body.classList.add(overlayInClass, overlayClass);
                        firstInput ? firstInput.focus() : {};
                    }

                    element[0].classList.toggle('active-link');
                }

                element.bind('click', () => setOverlayState());
            }

            $timeout(() => init());
        }
    };
};
